module.exports = "pegasus/assets/tech/safari/103.png";